<template>
	<el-dialog title="确认取消规则编辑？" :visible.sync="dialogVisible" width="320px" :before-close="handleClose">
		<div class="yx-color-text-primary">取消规则编辑将不会保存已编辑的规则</div>
		<span slot="footer">
			<el-button @click="cancel">取 消</el-button>
			<el-button type="primary" @click="save">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'cancelDialog',
	data() {
		return {
			dialogVisible: false,
		};
	},
	methods: {
		show() {
			this.dialogVisible = true;
		},
		handleClose() {
			this.dialogVisible = false;
		},
		cancel() {
			this.handleClose();
		},
		save() {
			this.$emit('back');
			this.handleClose();
		},
	},
};
</script>

<style lang="less" scoped></style>
